import { makeStyles } from '@mui/styles';
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  container: {
    border: `1px solid #E5EBF0`,
    borderRadius: '8px',
  },
  asterick: {
    color: colors.bgCritical,
  },
  headerSection: {
    padding: '16px',
    borderBottom: `1px solid #E5EBF0`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  heading: {
    fontWeight: '600',
  },
  deleteIconBtn: {
    width: '40px !important',
    minWidth: '40px !important',
    height: '40px',
    border: `1px solid ${colors.destructive200} !important`,
    color: `${colors.destructive500} !important`,
    padding: '12px 8px',
  },
  contentBox: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
  error: {
    marginTop: '-16px',
  },
  firstRow: {
    display: 'flex',
    alignItems: 'center',
  },
  controlGroup: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  label: {
    fontSize: 14,
    lineHeight: '20px',
    margin: 0,
    marginBottom: 8,
  },
});
